module.exports = __webpack_public_path__ + "src/asset/svg/prince.svg?534701d03b78a950096e2d564987f310";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/prince.svg
// module id = 91
// module chunks = 0